import { useReducer } from "react";
import { Modal, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button, Check } from "shared/ui";

const defaultValues = {
  private_time: false,
  return_trip: false,
  travel_line: false,
};

function CreateTravelLineModal({ handleClose, show, handleCreation }) {
  const { t } = useTranslation("Request");
  const [selectedTypes, handleTypeSelect] = useReducer((prev, e) => {
    return {
      ...defaultValues,
      [e.target.value]: e.target.checked,
    };
  }, defaultValues);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>{t("new_travel_line_modal.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Stack gap={4} className="p-3">
          <Check
            id="private-time-check"
            type="radio"
            changeHandler={handleTypeSelect}
            checked={selectedTypes.private_time}
            value="private_time"
            label={t("new_travel_line_modal.private_time")}
          />
          <Check
            id="return-trip-check"
            type="radio"
            changeHandler={handleTypeSelect}
            checked={selectedTypes.return_trip}
            value="return_trip"
            label={t("new_travel_line_modal.new_return_trip")}
          />
          <Check
            id="travel-line-check"
            type="radio"
            changeHandler={handleTypeSelect}
            checked={selectedTypes.travel_line}
            value="travel_line"
            label={t("new_travel_line_modal.new_travel_line")}
          />
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={handleClose}>
          {t("new_travel_line_modal.cancel")}
        </Button>
        <Button
          className="ms-auto"
          disabled={!Object.values(selectedTypes).some(Boolean)}
          onClick={() =>
            handleCreation(
              Object.entries(selectedTypes).filter(
                ([key, value]) => value
              )[0][0]
            )
          }
        >
          {t("new_travel_line_modal.create")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateTravelLineModal;
